const styles = require('../components/MentionsStyles.scss');

export default function getMentionClassName() {
    return styles.mentions;
}
